import { DirectiveBase } from '../angular-directive-base.directive';
import { StepperController } from './stepper.controller';

export class ActStepper extends DirectiveBase {
  constructor() {
    super();
    this.restrict = 'E';
    this.transclude = true;
    this.templateUrl = 'app/angularJS/components/stepper/act-stepper.html';
    this.scope = {
      moveForward: '=',
      moveBackward: '='
    };
    this.controller = StepperController;
    this.controllerAs = 'vm';
    this.bindToController = true;
  }

}